export default __webpack_public_path__ + "static/media/show8.4a2db6c0.jpeg";